<template>
    <div v-if="props.currentSubscription" class="addon-form">
        <div class="addon-form__addons">
            <paid-addon
                v-model="form.aiEmployees"
                :default="props.currentSubscription.plan.askNoaPlanAddon?.aiEmployees ?? 0"
                :price="AdditionalCostsCalculator.askNoaAddonCosts.aiEmployees"
                name="AI Agent"
                tooltip="Een krachtige AI Agent voor 99 euro per agent per maand."
            />
        </div>

        <div class="addon-form__footer">
            <flex-container
                :gap="Size.sm"
                align-items="center"
                justify-content="flex-end"
            >
                <text-decorator weight="bold">
                    Additionele kosten
                </text-decorator>
                <text-decorator weight="bold" :size="FontSize.xl">
                    {{ formatMoney(props.additionalCosts) }}
                </text-decorator>
            </flex-container>

            <flex-container justify-content="flex-end" align-items="center">
                <slot name="actions" />
            </flex-container>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue';
    import PaidAddon from '@/subscription/subscription/components/PaidAddon.vue';
    import { FontSize, Size } from '@keyvue/one-ui';
    import { formatMoney } from '@/shared/utils/money';
    import { AskNoaSubscriptionAddon, Subscription } from '@keyvue/one-api-client';
    import AdditionalCostsCalculator from '@/subscription/subscription/utils/AdditionalCostsCalculator';

    export interface Props {
        currentSubscription: Subscription
        loadedAdditionalCosts: number
        additionalCosts: number
    }

    export interface ExposedAskNoaAddonForm {
        form: AskNoaSubscriptionAddon,
        setForm: (values: Subscription) => void,
    }

    const props = defineProps<Props>();

    const form = ref<AskNoaSubscriptionAddon>(AskNoaSubscriptionAddon.fromObject({
        aiEmployees: 0,
    }) as AskNoaSubscriptionAddon);

    function setForm(subscription: Subscription) {
        if (!subscription.askNoaSubscriptionAddon) {
            return;
        }

        form.value.aiEmployees = subscription.askNoaSubscriptionAddon.aiEmployees;
    }

    defineExpose({
        form,
        setForm,
    });
</script>

<style scoped lang="scss">
    .addon-form {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 100%;

        &__addons {
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            padding-top: size(md);
            display: grid;
            gap: size(md);
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-auto-rows: 1fr;
        }

        &__footer {
            display: flex;
            flex-wrap: wrap;
            padding-top: size(xl);
            gap: size(md);
            width: 100%;
            align-self: flex-end;
        }
    }
</style>
